import { motion } from "framer-motion";
import "./style.css";
import { CrydFlagType, TaskType } from "../../Pages/Dashboard/types";

interface taskTypes {
  status: "To Do" | "In Progress" | "Done";
  crudFlag: CrydFlagType;
  isSelected: boolean;
  task: TaskType;
}

export const Task = ({ status, crudFlag, isSelected, task }: taskTypes) => {
  return (
    <motion.div
      className={`task-card transition-all
    ${
      crudFlag === "delete" && isSelected === true
        ? "scale-50 !bg-[#ef4444]/60"
        : crudFlag === "edit" && isSelected === true
        ? "scale-50 !bg-[#3b82f6]/60"
        : "scale-100"
    }
    `}
    >
      {status === "Done" && (
        <svg
          className="absolute w-full left-0 top-0 scale-x-[-1]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path
            fill="#34D399"
            fillOpacity="0.4"
            d="M0,160L24,149.3C48,139,96,117,144,101.3C192,85,240,75,288,64C336,53,384,43,432,74.7C480,107,528,181,576,186.7C624,192,672,128,720,96C768,64,816,64,864,106.7C912,149,960,235,1008,261.3C1056,288,1104,256,1152,240C1200,224,1248,224,1296,202.7C1344,181,1392,139,1416,117.3L1440,96L1440,0L1416,0C1392,0,1344,0,1296,0C1248,0,1200,0,1152,0C1104,0,1056,0,1008,0C960,0,912,0,864,0C816,0,768,0,720,0C672,0,624,0,576,0C528,0,480,0,432,0C384,0,336,0,288,0C240,0,192,0,144,0C96,0,48,0,24,0L0,0Z"
          ></path>
        </svg>
      )}
      {status === "In Progress" && (
        <svg
          className="absolute w-full left-0 bottom-0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path
            fill="#FBBF24"
            fillOpacity="0.3"
            d="M0,128L60,138.7C120,149,240,171,360,170.7C480,171,600,149,720,160C840,171,960,213,1080,213.3C1200,213,1320,171,1380,149.3L1440,128L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          ></path>
        </svg>
      )}{" "}
      {status === "To Do" && (
        <>
          <svg
            className="absolute w-full right-1/2 translate-x-6 bottom-0 rotate-90 scale-y-[-1]"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path
              fill="#ef4444"
              fillOpacity="0.3"
              d="M0,96L13.3,117.3C26.7,139,53,181,80,186.7C106.7,192,133,160,160,138.7C186.7,117,213,107,240,112C266.7,117,293,139,320,122.7C346.7,107,373,53,400,53.3C426.7,53,453,107,480,149.3C506.7,192,533,224,560,218.7C586.7,213,613,171,640,138.7C666.7,107,693,85,720,80C746.7,75,773,85,800,96C826.7,107,853,117,880,117.3C906.7,117,933,107,960,112C986.7,117,1013,139,1040,165.3C1066.7,192,1093,224,1120,218.7C1146.7,213,1173,171,1200,144C1226.7,117,1253,107,1280,133.3C1306.7,160,1333,224,1360,234.7C1386.7,245,1413,203,1427,181.3L1440,160L1440,0L1426.7,0C1413.3,0,1387,0,1360,0C1333.3,0,1307,0,1280,0C1253.3,0,1227,0,1200,0C1173.3,0,1147,0,1120,0C1093.3,0,1067,0,1040,0C1013.3,0,987,0,960,0C933.3,0,907,0,880,0C853.3,0,827,0,800,0C773.3,0,747,0,720,0C693.3,0,667,0,640,0C613.3,0,587,0,560,0C533.3,0,507,0,480,0C453.3,0,427,0,400,0C373.3,0,347,0,320,0C293.3,0,267,0,240,0C213.3,0,187,0,160,0C133.3,0,107,0,80,0C53.3,0,27,0,13,0L0,0Z"
            ></path>
          </svg>

          <svg
            className="absolute w-full left-1/2 -translate-x-7 bottom-0 rotate-90"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path
              fill="#ef4444"
              fillOpacity="0.3"
              d="M0,32L13.3,32C26.7,32,53,32,80,64C106.7,96,133,160,160,170.7C186.7,181,213,139,240,106.7C266.7,75,293,53,320,37.3C346.7,21,373,11,400,42.7C426.7,75,453,149,480,154.7C506.7,160,533,96,560,64C586.7,32,613,32,640,37.3C666.7,43,693,53,720,53.3C746.7,53,773,43,800,58.7C826.7,75,853,117,880,128C906.7,139,933,117,960,117.3C986.7,117,1013,139,1040,138.7C1066.7,139,1093,117,1120,122.7C1146.7,128,1173,160,1200,192C1226.7,224,1253,256,1280,277.3C1306.7,299,1333,309,1360,261.3C1386.7,213,1413,107,1427,53.3L1440,0L1440,0L1426.7,0C1413.3,0,1387,0,1360,0C1333.3,0,1307,0,1280,0C1253.3,0,1227,0,1200,0C1173.3,0,1147,0,1120,0C1093.3,0,1067,0,1040,0C1013.3,0,987,0,960,0C933.3,0,907,0,880,0C853.3,0,827,0,800,0C773.3,0,747,0,720,0C693.3,0,667,0,640,0C613.3,0,587,0,560,0C533.3,0,507,0,480,0C453.3,0,427,0,400,0C373.3,0,347,0,320,0C293.3,0,267,0,240,0C213.3,0,187,0,160,0C133.3,0,107,0,80,0C53.3,0,27,0,13,0L0,0Z"
            ></path>
          </svg>
        </>
      )}
      <div className="flex justify-between">
        <div className="task-title">{task.title}</div>
        <div
          className={`task-status 
        ${
          status === "Done"
            ? "text-[#34D399] bg-[#34D399]/20"
            : status === "In Progress"
            ? "text-[#FBBF24] bg-[#FBBF24]/20"
            : "text-[#EF4444] bg-[#EF4444]/20"
        }
        `}
        >
          {status}
        </div>
      </div>
      <div className="task-description">{task.description}</div>
      <div className="task-time">{task.due}</div>
    </motion.div>
  );
};
